var map = {
	"./alpha_low.svg": 63420,
	"./alpha_upper.svg": 4326,
	"./decimal.svg": 20062,
	"./none.svg": 84999,
	"./roman_low.svg": 33115,
	"./roman_upper.svg": 48885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66947;